import {combineReducers} from "redux";
import departmentReducer from "./reducer";

const reducer = combineReducers({
    departmentReducer,
})
  
export default reducer;